var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-center text-center py-8 text-dark-50 user-select-none"},[_c('img',{staticClass:"w-40px mb-4 opacity-40",attrs:{"src":"media/svg/icons/Files/Folder-minus.svg"}}),_c('div',{staticClass:"font-size-lg opacity-60"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }